import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { useState, useRef, useEffect } from 'react';
// Education and Experience Data
const educationData = [
    {
      id: 1,
      period: "2021 - Present",
      title: "Computer Science",
      institution: "Samara University",
      description: "Currently pursuing a Bachelor's degree in Computer Science with a focus on software development and system design.",
      skills: ["Java", "Python", "Algorithms", "Data Structures"],
      gpa: 3.5
    },
    {
      id: 2,
      period: "2018 - 2021",
      title: "High School Diploma",
      institution: "Sher Ethiopia Secondary School",
      description: "Completed secondary education with honors, focusing on science and mathematics.",
    },
    {
      id: 3,
      period: "January 2024 -  may 202",
      title: "Fullstack Development BootCamp",
      institution: "Udemy",
      description: "Completed secondary education with honors, focusing on science and mathematics.",
      skills: ["React", "Nodejs", "MoongoDb", "Data Structures","Expressjs"]
    }
  ];
  
  const experienceData = [
    {
      id: 1,
      period: "2024 - Present",
      title: "Fullstack Developer",
      company: "Asligroup",
      type: "Internship",
      description: "Contributing to scalable web applications development using modern technologies.",
      skills: ["React", "Node.js", "MongoDB", "AWS"],
      projects: ["E-commerce Platform", "Admin Dashboard"],
      impact: ["Improved site performance by 40%", "Implemented new features"]
    },
    {
      id: 2,
      period: "2023 - Present",
      title: "Freelance Developer",
      company: "Self-Employed",
      type: "Contract",
      description: "Managing client projects and delivering custom web solutions.",
      skills: ["Vue.js", "Firebase", "REST APIs", "UI/UX"],
      projects: ["Portfolio Sites", "Booking System"],
      impact: ["Completed 5+ projects", "5-star client ratings"]
    },
    {
      id: 3,
      period: "2024 - Present",
      title: "Fullstack Developer",
      company: "Self-Employed",
      type:  "Contract",
      description: "Contributing to scalable web applications development using modern technologies.",
      skills: ["React", "Node.js", "MongoDB", "AWS","expressjs"],
      projects: ["E-commerce Platform", "Admin Dashboard","Tourism Website"],
      impact: ["Improved site performance by 40%", "Implemented new features"]
    }
  ];
  

const TimelineSection = styled.section`
  min-height: 100vh;
  padding: 6rem 2rem;
  background: ${({ theme }) => theme.background};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 45%;
    height: 100%;
    background: ${({ theme }) => theme.gradient};
    opacity: 0.05;
    clip-path: polygon(0 0%, 100% 0%, 70% 100%, 0% 100%);
  }
`;

const TimelineContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const TimelineColumn = styled.div`
  position: relative;
`;

const SectionTitle = styled(motion.h2)`
  ${({ theme }) => theme.mixins.headingStyles};
  font-size: ${({ theme }) => theme.sizes['3xl']};
  color: ${({ theme }) => theme.text};
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;

  &::after {
    content: '';
    height: 4px;
    flex: 1;
    background: ${({ theme }) => theme.primary}30;
    border-radius: 2px;
  }
`;

const TimelineItem = styled(motion.div)`
  position: relative;
  padding: 2rem;
  background: ${({ theme }) => theme.card};
  border-radius: 16px;
  margin-bottom: 2rem;
  box-shadow: ${({ theme }) => theme.shadowMd};
  border: 1px solid ${({ theme }) => theme.border};
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: ${({ theme }) => theme.shadowLg};
  }

  &::before {
    content: '';
    position: absolute;
    left: -12px;
    top: 24px;
    width: 24px;
    height: 24px;
    background: ${({ theme }) => theme.primary};
    border-radius: 50%;
    box-shadow: 0 0 0 6px ${({ theme }) => theme.background};
  }
`;

const ItemTitle = styled.h3`
  ${({ theme }) => theme.mixins.headingStyles};
  font-size: ${({ theme }) => theme.sizes.xl};
  color: ${({ theme }) => theme.primary};
  margin-bottom: 0.5rem;
`;

const ItemSubtitle = styled.h4`
  ${({ theme }) => theme.mixins.bodyStyles};
  font-size: ${({ theme }) => theme.sizes.base};
  color: ${({ theme }) => theme.textLight};
  margin-bottom: 1rem;
`;

const ItemDescription = styled.p`
  ${({ theme }) => theme.mixins.bodyStyles};
  font-size: ${({ theme }) => theme.sizes.base};
  color: ${({ theme }) => theme.textMuted};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
`;

const TimelineBadge = styled.span`
  display: inline-block;
  padding: 0.25rem 1rem;
  background: ${({ theme }) => theme.primary}15;
  color: ${({ theme }) => theme.primary};
  border-radius: 20px;
  font-size: ${({ theme }) => theme.sizes.sm};
  margin-bottom: 1rem;
`;
const TimelineConnector = styled(motion.div)`
  position: absolute;
  left: -2px;
  top: 0;
  width: 4px;
  height: 100%;
  background: ${({ theme }) => theme.primary}30;
  z-index: 0;
`;

const TimelineProgress = styled(motion.div)`
  position: absolute;
  left: -2px;
  top: 0;
  width: 4px;
  background: ${({ theme }) => theme.primary};
  z-index: 1;
`;

const SkillTag = styled(motion.span)`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  margin: 0.25rem;
  background: ${({ theme }) => theme.primary}15;
  color: ${({ theme }) => theme.primary};
  border-radius: 15px;
  font-size: ${({ theme }) => theme.sizes.sm};
  cursor: pointer;
  
  &:hover {
    background: ${({ theme }) => theme.primary}30;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  margin-bottom: 2rem;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }
`;

const ExpandButton = styled(motion.button)`
  border: none;
  background: none;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  font-size: ${({ theme }) => theme.sizes.sm};
  margin-top: 1rem;
  
  &:hover {
    text-decoration: underline;
  }
`;

const DetailSection = styled(motion.div)`
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid ${({ theme }) => theme.border};
`;

const Experience = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [expandedItems, setExpandedItems] = useState(new Set());
    const [scrollProgress, setScrollProgress] = useState(0);
    const timelineRef = useRef(null);
    const filteredEducation = educationData.filter(item =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.institution.toLowerCase().includes(searchTerm.toLowerCase())
      );
    
      const filteredExperience = experienceData.filter(item =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.company.toLowerCase().includes(searchTerm.toLowerCase())
      );
    
      const toggleExpand = (id) => {
        setExpandedItems(prev => {
          const newSet = new Set(prev);
          if (newSet.has(id)) {
            newSet.delete(id);
          } else {
            newSet.add(id);
          }
          return newSet;
        });
      };
      useEffect(() => {
        const handleScroll = () => {
          if (timelineRef.current) {
            const element = timelineRef.current;
            const scrollTop = window.pageYOffset + window.innerHeight;
            const elementTop = element.offsetTop;
            const elementBottom = elementTop + element.offsetHeight;
            const scrollPercentage = Math.min(
              Math.max(
                ((scrollTop - elementTop) / (elementBottom - elementTop)) * 100,
                0
              ),
              100
            );
            setScrollProgress(scrollPercentage);
          }
        };
    
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);
return (
    <TimelineSection id="resume" ref={timelineRef}>
    <SearchInput
      placeholder="Search education or experience..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
    
    <TimelineContainer
      as={motion.div}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <TimelineColumn>
        <SectionTitle>Education 🎓</SectionTitle>
        <TimelineConnector />
        <TimelineProgress
          initial={{ height: "0%" }}
          style={{ height: `${scrollProgress}%` }}
        />
        
        <AnimatePresence>
          {filteredEducation.map((item) => (
            <TimelineItem
              key={item.id}
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -50, opacity: 0 }}
              whileHover={{ scale: 1.02 }}
            >
              <TimelineBadge>{item.period}</TimelineBadge>
              <ItemTitle>{item.title}</ItemTitle>
              <ItemSubtitle>{item.institution}</ItemSubtitle>
              <ItemDescription>{item.description}</ItemDescription>
              
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {item.skills?.map((skill) => (
                  <SkillTag
                    key={skill}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {skill}
                  </SkillTag>
                ))}
              </div>

              <ExpandButton onClick={() => toggleExpand(item.id)}>
                {expandedItems.has(item.id) ? 'Show Less' : 'Show More'}
              </ExpandButton>

              <AnimatePresence>
                {expandedItems.has(item.id) && (
                  <DetailSection
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                  >
                    <h4>Achievements:</h4>
                    <ul>
                      {item.achievements.map((achievement) => (
                        <li key={achievement}>{achievement}</li>
                      ))}
                    </ul>
                    <p>GPA: {item.gpa}</p>
                  </DetailSection>
                )}
              </AnimatePresence>
            </TimelineItem>
          ))}
        </AnimatePresence>
      </TimelineColumn>

      <TimelineColumn>
        <SectionTitle>Experience 💼</SectionTitle>
        <TimelineConnector />
        <TimelineProgress
          initial={{ height: "0%" }}
          style={{ height: `${scrollProgress}%` }}
        />
        
        <AnimatePresence>
          {filteredExperience.map((item) => (
            <TimelineItem
              key={item.id}
              initial={{ x: 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 50, opacity: 0 }}
              whileHover={{ scale: 1.02 }}
            >
              <TimelineBadge>{item.period}</TimelineBadge>
              <ItemTitle>{item.title}</ItemTitle>
              <ItemSubtitle>{`${item.company} - ${item.type}`}</ItemSubtitle>
              <ItemDescription>{item.description}</ItemDescription>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {item.skills?.map((skill) => (
                  <SkillTag
                    key={skill}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {skill}
                  </SkillTag>
                ))}
              </div>

              <ExpandButton onClick={() => toggleExpand(item.id)}>
                {expandedItems.has(item.id) ? 'Show Less' : 'Show More'}
              </ExpandButton>

              <AnimatePresence>
                {expandedItems.has(item.id) && (
                  <DetailSection
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                  >
                    <h4>Projects:</h4>
                    <ul>
                      {item.projects.map((project) => (
                        <li key={project}>{project}</li>
                      ))}
                    </ul>
                    <h4>Impact:</h4>
                    <ul>
                      {item.impact.map((impact) => (
                        <li key={impact}>{impact}</li>
                      ))}
                    </ul>
                  </DetailSection>
                )}
              </AnimatePresence>
            </TimelineItem>
          ))}
        </AnimatePresence>
      </TimelineColumn>
    </TimelineContainer>
  </TimelineSection>
  );
};

export default Experience;